export default {
    login_register: 'Login/Register',
    booking_confirmation_title: 'Booking confirmation',
    booking_confirmation_body: 'Thank you for your booking. Please find confirmation details below.',
    insurance_requirements_modal_disclaimer: `By making this booking, I am confirming that: I have had no convictions or motoring offences during the
    last 5 years. I have not had a proposal declined, a policy cancelled or renewal refused or been required
    to pay an increased premium or had any special conditions imposed by any motor insurer. I have not been
    disqualified from driving. I do not have a prosecution or police enquiry pending. I do not have any
    convictions for offences relating to theft, fraud, or dishonesty within the last 5 years. I have not
    suffered from defective vision or hearing (not corrected by glasses or hearing aid), heart disorder,
    diabetes, fits or any physical or mental infirmity of any kind. I have not had any accidents in the last
    5 years. Please click {0} if you do not meet these requirements`,
    insurance_requirements_here: 'here',
    insurance_requirements: 'I have read and understood the {0}',
    ir: 'Insurance Requirements',
    location: 'Location',
    pickup_location: 'Pickup Location',
    dropoff_location: 'Dropoff Location',
    vehicle: 'Vehicle',
    pickup_and_dropoff: 'Pickup and Dropoff (local time)',
    view_voucher: 'View Voucher',
    identity_verification_body: 'You will be required to verify your identity before collecting the vehicle',
    identity_verification_title: 'Verify Identity',
    search_again: 'Search again',
    refrigerated: 'refrigerated',
    aircon_lower: 'aircon',
    aircon: 'Air con',
    refrigeration: 'Refrigerated',
    not_available: 'Drive & Go is currently only available for people with identity and driving license documents from the following countries.',
    check_if_included: 'Check if your country is included.',
    included_in_booking: 'Included in this booking',
    cdw_with_excess: 'CDW with excess',
    theft_protection: 'Theft protection with excess',
    risk_reduction: 'Risk reduction',
    free_extras: 'You are entitled to two free extras <br /> with this booking.',
    continue: 'Continue',
    luggage_large_short_label: 'L',
    luggage_medium_short_label: 'M',
    luggage_small_short_label: 'S',
    luggage_large_long_label: 'large',
    luggage_medium_long_label: 'medium',
    luggage_small_long_label: 'small',
    fuel_unspecified_label: 'unspecified',
    transmission_manual_label: 'Manual',
    transmission_automatic_label: 'Automatic',
    make_a_booking: 'Make a booking',
    pickup_date: 'Pickup date',
    dropoff_date: 'Dropoff date',
    driver_age: 'Driver between 30 - 65',
    enter_driver_age: "Please enter the driver's age",
    promo_code: 'Promo Code',
    search: 'Search',
    dropoff_date_cannot_be_before_pickup_date: 'The dropoff date cannot be before the pickup date',
    pickup_date_cannot_be_in_the_past: 'The pickup date cannot be in the past',
    pickup_time_cannot_be_in_the_past: 'The pickup time cannot be in the past',
    dropoff_time_must_be_later_than_the_pickup_time_if_on_the_same_day: 'The dropoff time must be later than the pickup time if on the same day',
    vehicle_filters: 'Vehicle filters',
    reset: 'Reset',
    transmission: 'Transmission',
    all: 'All',
    manual: 'Manual',
    auto: 'Auto',
    passengers: 'Passengers',
    vehicle_type: 'Vehicle type',
    filter: 'Filter',
    vehicle_search: 'Vehicle search',
    edit: 'Edit',
    no_results: 'No results match your filter criteria.',
    small_cars: 'Small cars',
    medium_cars: 'Medium cars',
    large_cars: 'Large cars',
    estate_cars: 'Estate cars',
    suvs: 'SUVs',
    mpvs: 'MPVs',
    vans: 'Vans',
    camper_vans: 'Camper vans',
    premium: 'Premium',
    unspecified: 'unspecified',
    large: 'large',
    medium: 'medium',
    small: 'small',
    automatic: 'automatic',
    you_have_been_refunded: 'You have been refunded.',
    please_customer_service: 'To make a booking please contact our customer service.',
    contact_customer_service: 'Contact customer services',
    booking_failed: 'Your booking could not be processed this time.',
    summary: 'Summary',
    reforestation_and_protection: 'Support reforestation and protection of the rain forest throughout Costa Rica',
    cost_of_rental: 'Cost of rental',
    to_pay_now: 'To pay now',
    greenheart_donation: 'Green heart donation',
    total_cost: 'Total cost of rental',
    tc_agreement: 'I have read and understood the {0}.',
    tc: 'T&Cs',
    receive_offers: 'I would like to receive special offers by email.',
    donate: 'Yes, I would like to donate {amount}',
    pay_now: 'Pay {amount} now',
    driver_details: "Driver's details",
    complete_driver_details: "Please complete the driver's details.",
    are_you_the_driver: 'Are you the driver?',
    have_an_account: 'Do you already have an account?',
    login: 'Login',
    or: 'or',
    first_name: "Driver's First name",
    last_name: "Driver's Last name",
    email: 'Email address',
    phone_number: 'Mobile phone number',
    unable_to_save_driver_information: 'Unable to save the driver information. Please try again.',
    pay_online_now: 'Pay online now',
    day: 'Day',
    choose_location: 'Choose a location',
    location_not_found: "Sorry, we couldn't find the location you requested.",
    add: 'Add',
    remove: 'Remove',
    free_extra: 'Free extra',
    free: 'FREE!',
    fast_track_notice: 'Document origin restrictions apply for this service. It is only available for people with documents from',
    complete_booking: 'Complete Booking',
    choose_card: 'Please choose a card or add a new one.',
    add_billing_details: 'Please add billing details.',
    card_number: 'Card number',
    card_holder_name: "Card holder's name",
    card_exp: 'MM / YY',
    card_cvc: 'CVC',
    save_card: 'Save card?',
    amount_charged: 'Your card will be charged',
    payment_confirmation: 'Confirm booking and pay',
    payment_methods: 'available payment methods',
    use_saved_card: 'x use saved card',
    use_different_card: '+ use a different card',
    book_now: 'Book now',
    minimum_age: "Over {age}'s Only",
    excess_liability: 'Excess liability',
    security_deposit: 'Security deposit',
    fuel_policy: 'Fuel policy',
    like_for_like: 'Like for Like',
    full_to_full: 'Full to Full',
    miles_per_rental: '{mileage} free miles per rental',
    km_per_rental: '{mileage} free km per rental',
    unlimited_mileage: 'Unlimited mileage',
    unlimited_mileage_km: 'Unlimited km',
    non_amendable: 'Non amendable',
    non_refundable: 'Non refundable',
    free_cancellation_until: 'Free cancellation up until',
    cancellation_in_line_with: 'Cancellation in line with',
    tcs: 'T&amp;Cs',
    free_extras_on_collection: 'Two free extras on collection',
    glass_and_tyres_covered: 'Glass and tyres covered',
    number_of_passengers: 'Number of passengers',
    number_of_bags: 'Number of bags',
    fuel_type: 'Fuel type',
    co2: 'CO2',
    book_type: 'Book {type}',
    processing: 'Processing',
    actual_price: 'Actual price',
    tooltip: 'Price in {currencyCode} is an estimate based on an exchange rate, the price in {currency} is binding.',
    deposit: 'Deposit',
    pay_online: 'Pay online now',
    pay_online_without_extras: 'Rental price',
    extras_on_arrival: 'Extras on arrival',
    insurance_on_arrival: 'Risk reduction - Pay on arrival',
    insurance_online: 'Risk reduction - Pay now',
    extras_online: 'Extras pay now',
    green_heart_donation: 'Green Heart donation',
    why_use_drive_and_go: 'Why use Drive & Go?',
    straight_to_car: 'Straight to car',
    no_queues: 'No queues',
    self_checkout: 'Self checkout',
    cant_lose_key: "Can't lose the key",
    online_id_check: 'Online ID check',
    phone_as_key: 'Phone as a key',
    premiumplus_benefits_includes: 'Premium Plus+ benefits also included',
    book_drive_go: 'Book Drive & Go',
    distance_allowance: 'Distance Allowance',
    duration: 'Duration',
    view_more_bookings: 'View More Bookings',
    to_pay_on_arrival: 'To pay on arrival',
    pay_on_arrival: 'Pay on arrival',
    unlimited: 'Unlimited',
    return_date: 'Return Date',
    postcode: 'Postcode',
    country: 'Country',
    drive_and_go: {
        drive_and_go: 'Drive And Go',
        available_countries: 'Drive &amp; Go is currently only available for people with identity and driving license documents from the following countries:',
        drive_and_go_today: 'Drive & Go booking today!',
        drive_and_go_shortened: 'Drive & Go',
        why_use_drive_and_go: 'Why use Drive & Go?',
        straight_to_car: 'Straight to car',
        no_queues: 'No queues',
        self_checkout: 'Self checkout',
        cannot_lose_the_key: "Can't lose the key",
        online_id_check: 'Online ID check',
        phone_as_a_key: 'Phone as a key',
        premium_plus_benefits_also_included: 'Premium Plus+ benefits also included',
        book_drive_and_go: 'Book Drive & Go',
    },
    car_and_camp: {
        tent_and_equipment: 'Tent and equipment',
        quick_and_easy: 'Quick and easy to set up',
        travel_freedom: 'Travel freedom',
        affordable_campervan_alternative: 'Affordable Campervan Alternative',
        lightweight_and_compact: 'Lightweight and Compact',
        fully_insured: 'Fully Insured',
    },
    my_bookings: 'My bookings',
    no_bookings: 'No bookings',
    my_profile: 'My Profile',
    no_bookings_to_display: 'No bookings to display.',
    search_great_car_rental_deals: 'Search great car rental deals for your next trip.',
    odometer_at_collection: 'Odometer at collection',
    fuel_at_collection: 'Fuel at collection',
    start_check_in: 'Start check-in',
    start_collection: 'Start collection',
    recent_bookings: 'Recent bookings',
    damage: {
        updated_damage_report_submitted: 'An updated damage report has been submitted. A member of our customer service team will be in touch if required.',
        add_additional_damage: 'Add additional damage',
        you_may_report_additional_damage_up_to: 'You may report additional damage up to 24 hours after vehicle checkout',
        specify_damage: 'Specify damage',
        please_choose_the_area_and_type_of_damage: 'Please choose the area and type of damage',
        type_of_damage: 'Type of damage',
        is_this_more_than_5_cm: 'Is this more than 5cm?',
        please_take_or_select_a_photo: 'Please take or select a photo',
        please_take_a_photo_ensuring_the_damage_is_clearly_visible: 'Please take a photo ensuring the damage is clearly visible',
        if_you_require_you_may_add_another_photo_select_the_icon_to_add_another_photo: ' If required you may add another photo, select the icon to add another photo',
        save_image: 'Save Image',
        save_images: 'Save Images',
        damage_saved_successfully: 'Damage saved successfully',
        add_photo: 'Add photo',
    },
    checkout: {
        start_collection: 'Start Collection',
        collect_vehicle: 'Collect Vehicle',
        we_will_let_you_know_the_details: "We'll let you know the location and details to enable you to locate the hire vehicle.",
        inspect: 'Inspect',
        we_will_ask_for_four_photos_from_each_corner: "We'll ask for four photos from each corner of the vehicle along with any new damage not already listed.",
        fuel_and_milage: 'Fuel & Mileage',
        you_confirm_the_readings_at_the_start_of_your_hire: 'You confirm the odometer and fuel readings at the start of your hire.',
        sign: 'Sign',
        sign_the_rental_agreement: 'Sign the rental agreement.',
        away_you_go: 'Away you go',
        you_are_free_to_take_to_the_road: "You're free to take to the road!",
        collect_your_vehicle: 'Collect your vehicle',
        get_directions: 'Get Directions',
        hide_directions: 'Hide Directions',
        local_time: 'local time',
        tel: 'Tel',
        getting_to_the_location: 'Getting to the location',
        get_vehicle_details: 'Get vehicle details',
        view_map: 'View Map',
        unlock_vehicle_and_continue: 'Unlock vehicle & continue',
        unable_to_connect_to_vehicle: 'Unable to connect to vehicle',
        we_were_unable_to_connect_to_the_vehicle_please_check: 'We were unable to connect to the vehicle - please check you are next to the right vehicle, and try again.',
        we_were_unable_to_find_the_vehicle_booking_please_try_again_later: 'We were unable to find the vehicle booking. Please try again later.',
        odometer_and_fuel: 'Odometer & fuel',
        odometer: 'Odometer',
        please_confirm_the_odometer_and_fuel_readings: 'If possible, please confirm the odometer and fuel readings.',
        the_odometer_field_is_required: 'The odometer field is required',
        and_must_be_greater_than_the_checkout_odometer: '& must be greater than the check-out odometer',
        confirm: 'Confirm',
        please_take_a_photo_from_each_corner_of_the_vehicle: 'Please take a photo from each corner of the vehicle',
        pre_existing_damage: 'Pre-existing Damage',
        no_pre_existing_damage: 'No pre-existing damage.',
        new_damage: 'New Damage',
        add_additional_damage: 'add additional damage',
        no_new_damage_to_report: 'No new damage to report',
        checkout_complete: 'Checkout complete',
        start_rental: 'Start rental',
        congratulations_name_it_is_time_to_take_to_the_road: "Congratulations {customer_name}, it's time to take to the road!",
        we_are_unable_to_complete_your_vehicle_checkout: "We're unable to complete your vehicle checkout.",
        please_do_the_following: 'Please do the following',
        remove_all_belonging_and_lock_the_vehicle: 'Remove all belonging and lock the vehicle.',
        lock_vehicle: 'Lock Vehicle',
        once_you_have_contacted_customer_services: "Once you've contacted customer services",
        vehicle_location: 'Vehicle Location',
        collect_your: 'Collect Your',
        from: 'From',
        key_in_glove_box: 'your key is located in glove box',

        keyholder: {
            not_detected: 'Key not detected in keyholder',
            not_detected_please_try_again: 'Please place your key in the keyholder, and then try again.',

            not_installed: 'Keyholder not installed',
            not_installed_please_contact_customer_service: 'Keyholder is not installed, please contact customer service.',
        },
        keyring: {
            look_up_failed: 'Keyring look up failed',
            look_up_failed_please_contact_customer_service: 'Keyring look up faled, please contact customer service.',
        },
        key: {
            invalid: 'Key is invalid',
            invalid_please_contact_customer_service: 'Your key is invalid, please contact customer service.',

            expired: 'Key has expired',
            expired__please_contact_customer_service: 'Your key has expired, please contact customer service.',
        },
    },
    checkin: {
        start_check_in: 'Start check-in',
        vehicle_location: 'Vehicle Location',
        tell_us_where_you_have_parked: "Tell us where you've parked the vehicle.",
        fuel_and_milage: 'Fuel & Mileage',
        you_confirm_the_readings_at_the_end_of_your_hire: 'You confirm the odometer and fuel readings at the end of your hire.',
        inspect: 'Inspect',
        we_will_as_for_four_photos_from_each_corner_of_the_vehicle_along_with_any_new_damage:
            "We'll ask for four photos from each corner of the vehicle along with any new damage incurred during the hire.",
        lock: 'Lock',
        check_you_have_left_no_belonging_then_lock_the_vehicle: "Check you've left no belonging then lock the vehicle.",
        please_tell_us_where_you_have_parked_the_vehicle: "Please tell us where you've parked the vehicle",
        once_the_vehicle_is_locked_you_will_be_unable_to_unlock_it_again: 'Once the vehicle is locked, you will be unable to unlock it again.',
        name_please_check_you_have_left_no_belongings_then_lock_the_vehicle:
            "{first_name}, please check you've left no belongings, lock the vehicle and if required return the physical key to the key holder.",
        lock_vehicle: 'Lock Vehicle',
        complete_check_in: 'Complete Check-in',
        inspection: 'Inspection',
        complete_vehicle_check_in: 'Complete vehicle check-in',
        we_are_unable_to_complete_your_vehicle_check_in: "We're unable to complete your vehicle check-in.",
        please_contact_customer_services: 'Please contact customer services',
        once_you_have_contacted_customer_services: "Once you've contacted customer services",
        please_amend_odometer_to_be_greater_than: 'Please amend odometer to be greater than {odometer_value}',
    },
    rental_agreement: {
        rental_agreement: 'Rental agreement',
        agreement_between: 'Agreement Between',
        and: 'and',
        sign_rental_agreement: 'Sign rental agreement',
        i_have_read_and_understood_the_terms_and_conditions: 'I have read and understood the Terms & Conditions and accept the condition of the vehicle',
    },
    additional_options: 'Additional Options',
    booking_details: 'Booking Details',
    price_for_x_days: 'Price for {qty_of_days} day | Price for {qty_of_days} days',
    cancelled: 'Cancelled',
    upcoming: 'Upcoming',
    active: 'Active',
    full_insurance_no_deposit: 'Full insurance & no deposit required',
    excess: '{amount} excess',
    deposit: '{amount} deposit',
    included_daily_distance: '{distance} {unit} per day',
    miles: 'miles',
    kilometers: 'kilometers',
    collection_details_title: 'Collection Details',
    collection_details_not_found: 'No collection details defined for this location',
    free_cancellation: 'Free Cancellation',
    no_deposit: 'No Deposit',
    benefit_from: 'Benefit From',
    for_only_per_day: 'For only {price} per day',
    upgrade_mee: 'UpgradeMee',
};
